import script from "./paymentPurchase.vue?vue&type=script&setup=true&lang=js"
export * from "./paymentPurchase.vue?vue&type=script&setup=true&lang=js"

import "./paymentPurchase.vue?vue&type=style&index=0&id=55358f6f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55358f6f"]])

export default __exports__